import { FC } from "react";
import { IconPropsType } from ".";

export const Phone: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9645 19H16.6828C15.1454 19 13.637 18.5822 12.3187 17.7912C9.81147 16.2869 7.71312 14.1885 6.20881 11.6813L6.15739 11.5957C5.40005 10.3334 5 8.8891 5 7.4171C5 5.98247 5.94103 4.71769 7.31516 4.30545L7.70008 4.18998C8.0805 4.07585 8.49171 4.21117 8.73001 4.52891L9.93333 6.13333C10.4667 6.84444 10.4667 7.82222 9.93333 8.53333L9.42199 9.21512C9.21444 9.49186 9.18105 9.86211 9.33576 10.1715C10.3078 12.1157 11.8843 13.6922 13.8285 14.6642C14.1379 14.8189 14.5081 14.7856 14.7849 14.578L15.3697 14.1394C16.1258 13.5723 17.1755 13.6119 17.8867 14.2342L19.4949 15.6413C19.8004 15.9087 19.914 16.3342 19.7823 16.7182L19.6602 17.0745C19.2653 18.2263 18.1821 19 16.9645 19Z"
        stroke={props.color}
        strokeWidth="1.5"
      />
    </svg>
  );
};
